import { render, staticRenderFns } from "./detailTable.vue?vue&type=template&id=6c5a19cb&"
import script from "./detailTable.vue?vue&type=script&lang=js&"
export * from "./detailTable.vue?vue&type=script&lang=js&"
import style0 from "./detailTable.vue?vue&type=style&index=0&id=6c5a19cb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports